import { ArtTile, formatInt } from '../index.js';

import type { StyleWithVars } from '../index.js';
import type { PartyWrapped } from '@mixwire/contracts';
import type { ReactElement } from 'react';

type Slide05TopTracksProps = {
  readonly wrapped: PartyWrapped;
};

const FIRST_ROW_DELAY_MS = 350;
const ROW_STAGGER_MS = 150;

const playsLabel = (plays: number): string =>
  plays === 1 ? '1 play' : `${formatInt(plays)} plays`;

export const Slide05TopTracks = ({ wrapped }: Slide05TopTracksProps): ReactElement => {
  const { topTracks } = wrapped;

  return (
    <>
      <h2 className="big rise">
        {topTracks.some((track) => track.plays > 1) ? 'The tracks on repeat' : 'What got played'}
      </h2>
      {topTracks.length === 0 ? (
        <p className="lede rise">Nothing on the decks was logged clearly enough to rank.</p>
      ) : (
        <ol className="tracks">
          {topTracks.map((track, index) => {
            const rowStyle: StyleWithVars = {
              '--d': String(FIRST_ROW_DELAY_MS + index * ROW_STAGGER_MS),
            };

            return (
              <li
                className="slidein"
                key={track.trackId ?? `${String(index)}-${track.name}`}
                style={rowStyle}
              >
                <span className="rank" aria-hidden="true">
                  {formatInt(index + 1)}
                </span>
                <ArtTile album={track.album} artUrl={track.artUrl} label={track.name} />
                <span className="meta">
                  <b>{track.name}</b>
                  <span>{track.artists.join(', ')}</span>
                </span>
                <span className="plays">{playsLabel(track.plays)}</span>
              </li>
            );
          })}
        </ol>
      )}
    </>
  );
};
